export default __webpack_public_path__ + "static/media/product-1.c3ec83b9.jpg";